import numeral from 'numeral';

export function string2money(value: string | number): string {
  return numeral(`${value}`).format('0,0.[00]');
}

export function money2number(value: string): number {
  return numeral(value).value();
}
